import { render, staticRenderFns } from "./IFrameLoader.vue?vue&type=template&id=61a0b212&scoped=true"
import script from "./IFrameLoader.vue?vue&type=script&lang=ts"
export * from "./IFrameLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0b212",
  null
  
)

export default component.exports